import { render, staticRenderFns } from "./RatesDashboard.vue?vue&type=template&id=b7aef2fe&scoped=true&"
import script from "./RatesDashboard.vue?vue&type=script&lang=js&"
export * from "./RatesDashboard.vue?vue&type=script&lang=js&"
import style0 from "./RatesDashboard.vue?vue&type=style&index=0&id=b7aef2fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7aef2fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7aef2fe')) {
      api.createRecord('b7aef2fe', component.options)
    } else {
      api.reload('b7aef2fe', component.options)
    }
    module.hot.accept("./RatesDashboard.vue?vue&type=template&id=b7aef2fe&scoped=true&", function () {
      api.rerender('b7aef2fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Rates/RatesDashboard.vue"
export default component.exports